// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Meta from "vue-meta";
import Formsecciones from "./views/forms/FormularioSecciones";
import App from "./App";
import router from "./router";
import Pace from "pace-progress";
import EventNotiArticulos from "./components/EvenNotiArticulos";
import EventosMes from "./components/EventosMes";

Vue.component("formsecciones", Formsecciones);
Vue.component("eventarticulos", EventNotiArticulos);
Vue.component("eventosmes", EventosMes);

Vue.use(Meta);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  mounted: function() {
    Pace.start();
    Pace.on("hide", () => {
      document.dispatchEvent(new Event("app.rendered"));
    });
  },
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js